module.exports = __webpack_public_path__ + "static/razer1-f740f1b4985e054e99f432b7612bb0c5.jpg";